import {ApiClient} from '@hconnect/apiclient'
import {StoppageEvent} from '@hconnect/common/stoppages/types/stoppage.types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

type UseStoppageEventOptions = Omit<
  UseQueryOptions<StoppageEvent, AxiosError>,
  'initialData' | 'queryKey'
>

const QueryKey = 'stoppage-event'

export const useStoppageEvent = (
  plantId: string,
  stoppageId?: string,
  options?: UseStoppageEventOptions
) => {
  const path = `/shifthandover/${plantId}/events/${stoppageId}`

  return useQuery<StoppageEvent, AxiosError>({
    queryKey: [QueryKey, stoppageId, plantId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<StoppageEvent>(path, {signal})
      return response.data
    },
    ...options,
    enabled: options?.enabled ?? stoppageId !== undefined
  })
}
